import React, { useEffect, useState } from "react";
import "./Finance.scss";
import {
  Card,
  Col,
  Container,
  Row,
} from "reactstrap";
import searchIcon from "../../assets/images/search-normal.png";
import "nouislider/distribute/nouislider.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { createSelector } from "reselect";
import { getStatementOrderDetailThunk } from "live-slices/OrderStatements/thunks";
import ErrorModal from "Components/Common/ErrorModal";
import DropDown from "../../assets/images/dropDownIcon.png";

import BreadCrumbforback from "Components/Common/BreadCrumbForBack";
import { motion } from "framer-motion";

const StateMentOverview = (props: any) => {
  document.title = "Products | BuyPass";
  const dispatch: any = useDispatch();
  const [activeBar, setActiveBar] = useState<any>("incomeOverview");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const [activeTab, setActiveTab] = useState<any>("Order");


  const toggleDetails = (index: number) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  const params = useParams();

  const location = useLocation();
  const statementId =
    location.state?.statementId ||
    params.id ||
    new URLSearchParams(location.search).get("statementId");

  console.log("statementId", statementId);

  const selectedStatementOrderData = createSelector(
    (state: any) => state.OverViewStatement,
    (IcomeOverViewDetail) => IcomeOverViewDetail?.IcomeOverViewDetail
  );
  const statementDetail = useSelector(selectedStatementOrderData);

  const [orderDetail, setorderDetail] = useState<any>({});

  useEffect(() => {
    dispatch(getStatementOrderDetailThunk(statementId));
    setorderDetail(statementDetail);
  }, []);

  const formatDate = (timestamp: number): string => {
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' }); // e.g., "May"
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const downloadCSV = () => {
    const rows = [
      ["Statement Number", statementDetail.statementNumber || "-"],
      [
        "Statement Status",
        statementDetail.status === "toBeReleased"
          ? "To Be Released"
          : statementDetail.status || "-",
      ],
      [
        "Expected Payout Date",
        `${formatDate(statementDetail.createdOn)} - ${formatDate(statementDetail.modifiedOn)}`,
      ],
      ["Opening Balance", statementDetail.openingBalance || 0],
      ["Subtotal", statementDetail.buyerPaymentInformation?.feeName?.subTotal || 0],
      ["Payment Fees", statementDetail.buyerPaymentInformation?.feeName?.PaymentFee || 0],
      ["Commission Fee", statementDetail.buyerPaymentInformation?.feeName?.commissionFee || 0],
      ["Shipping Fee Discount", statementDetail.buyerPaymentInformation?.feeName?.shippingFee || 0],
      ["Free Shipping Max Fee", 0],

      ["Subtotal", statementDetail.buyerPaymentInformation?.deliveredOrders?.subTotal || 0],
      ["Shipping Fee Paid by Buyer", statementDetail.buyerPaymentInformation?.deliveredOrders?.shippingFeePaidByBuyer || 0],
      ["Product Price Paid by Buyer", statementDetail.buyerPaymentInformation?.deliveredOrders?.productPricePaidByBuyer || 0],
      ["Co funded Vouchers", 0],

      ["Closing Balance", "", statementDetail.buyerPaymentInformation?.closingBalance || 0],
    ];

    const csvContent = rows
      .map((row) =>
        row
          .map((cell) => `"${String(cell).replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `statement_${statementDetail.statementNumber || "data"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <div className="page-content page-content-mobile">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
        <BreadCrumbforback
          title="Statement Overview"
          pageTitle="My Income"
          pageTitleRoute="/my-income"
        />
        <ErrorModal
          show={showModal.isVisible}
          message={errorMessage}
          color={showModal.color}
          onCloseClick={() => setShowModal({ isVisible: false, color: false })}
        />
      </Container>

      <Row style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
        <Card>
          <div className="CLASS_MAIN">
            <div className="OVERview">
              <div>
                <h6>Statement Overview</h6>
                <h3>
                  Rs. <span>{statementDetail?.openingBalance || 0}</span>
                </h3>
              </div>
              <div className="Download" onClick={downloadCSV}>
                   <div className="button">
                                 <h6>Download</h6>
                                 <img src={DropDown} alt="" />
                               </div>
              </div>
              {/* <div className="AndSelect">
                <div className="select-And-Inputs">
                  <select
                    // value={status}
                    data-testing-id="statusSelect_PromotionListing"
                  >
                    <option
                      value=""
                      data-testing-id="selectStatusOption_PromotionListing"
                    >
                      Downlaod
                    </option>
                    <option
                      value="true"
                      data-testing-id="activeOption_PromotionListing"
                    >
                      Active
                    </option>
                    <option
                      value="false"
                      data-testing-id="inactiveOption_PromotionListing"
                    >
                      Inactive
                    </option>
                  </select>
                </div>
              </div> */}
            </div>
            <div className="statement-number">
              <p>
                Statement Number :{" "}
                <span>{statementDetail.statementNumber || "-"}</span>
              </p>
              <h5>
                Statement Status:{" "}
                <span>
                  {statementDetail.status === "toBeReleased"
                    ? "To Be Released"
                    : statementDetail.status || "-"}
                </span>
              </h5>

              <p>
                <span>
                  Expected Payout Date: {formatDate(statementDetail?.createdOn)} - {formatDate(statementDetail?.modifiedOn)}
                </span>
              </p>
            </div>
            <div className="Table-miaN">
              <div className="GirthWidth">
                <div className="girth-One">
                  <h6>Fee Type</h6>
                </div>
                <div className="girth-Two">
                  <h6>Fee Name</h6>
                </div>
                <div className="girth-Three">
                  <h6>Fee Account</h6>
                </div>
              </div>
              <div className="GirthWidtH">
                <div className="girth-One">
                  <div>
                    <p>Opening Balance</p>
                  </div>
                </div>
                <div className="girth-Two">
                  {/* <h6>14 April 2025 16:34</h6> */}
                </div>
                <div className="girth-Three">
                  <div>
                    <p>
                      Rs. <span>{statementDetail?.openingBalance || 0}</span>
                    </p>
                  </div>
                </div>


              </div>
                <div className="GirthWidtH">
                <div className="girth-One">
                  <div>
                    <p>Total Delivered Amount</p>
                  </div>
                </div>
                <div className="girth-Two">
                  {/* <h6>14 April 2025 16:34</h6> */}
                </div>
                <div className="girth-Three">
                  <div>
                    <p>
                      Rs. <span>{statementDetail?.totalDeliveredOrdersAmount || 0}</span>
                    </p>
                  </div>
                </div>


              </div>
              <div className="GirthWidtH">
                <div className="girth-One">
                  <div>
                    <p>Transaction Fees</p>
                  </div>
                </div>
                <div className="girth-Two">
                  {/* <h6>14 April 2025 16:34</h6> */}
                  <p>Commission Fee</p>
                  <p>Package Handling Fee</p>
                  <p>Cash Handling Fee</p>
                  <p>Tax Fee</p>
                  <p>Subtotal</p>
                </div>
                <div className="girth-Three">
                  <div>
                   
                    <p>
                      Rs. <span> {statementDetail?.transactionFee?.commission || 0}</span>
                    </p>
                    <p>
                      Rs. <span>{statementDetail?.transactionFee?.packageHandling || 0}</span>
                    </p>
                     <p>
                      Rs. <span>{statementDetail?.transactionFee?.cashHandlingFee || 0}</span>
                    </p>
                    <p>
                      Rs. <span>{statementDetail?.transactionFee?.tax || 0}</span>
                    </p>
                     <p>
                      Rs. <span>{(statementDetail?.transactionFee?.commission + statementDetail?.transactionFee?.packageHandling + statementDetail?.transactionFee?.cashHandlingFee + statementDetail?.transactionFee?.tax) || 0}</span>
                    </p>
                  </div>
                </div>
              </div>
                    <div className="GirthWidtH">
                <div className="girth-One">
                  <div>
                    <p>Returns Order Amount</p>
                  </div>
                </div>
                <div className="girth-Two">
                  <h6></h6>
                </div>
                <div className="girth-Three">
                  <div>
                    <h6>
                      Rs. <span>{statementDetail?.totalReturnOrdersAmount || 0}</span>
                    </h6>
                   
                  </div>
                </div>
              </div>
                      <div className="GirthWidtH">
                <div className="girth-One">
                  <div>
                   <h6>Total</h6>
                  </div>
                </div>
                <div className="girth-Two">
                  <h6></h6>
                </div>
                <div className="girth-Three">
                  <div>
                    <h6>
                      Rs. <span>{((statementDetail?.totalDeliveredOrdersAmount + statementDetail?.openingBalance) - (statementDetail?.transactionFee?.commission + statementDetail?.transactionFee?.packageHandling + statementDetail?.transactionFee?.cashHandlingFee + statementDetail?.transactionFee?.tax) - (statementDetail?.totalReturnOrdersAmount) ) || 0}</span>
                    </h6>
                   
                  </div>
                </div>
              </div>
              {/* <div className="GirthWidtH">
                <div className="girth-One">
                  <div>
                    <p>Delivered Orders</p>
                  </div>
                </div>
                <div className="girth-Two">
                  <h6>Subtotal</h6>
                  <p>Shipping Fee Paid by Buyer</p>
                  <p>Product Price Paid by Buyer</p>
                  <p>Co funded Vouchers</p>
                </div>
                <div className="girth-Three">
                  <div>
                    <h6>
                      Rs. <span>{statementDetail?.buyerPaymentInformation?.deliveredOrders?.subTotal || 0}</span>
                    </h6>
                    <p>
                      Rs. <span>{statementDetail?.buyerPaymentInformation?.deliveredOrders?.shippingFeePaidByBuyer || 0}</span>
                    </p>
                    <p>
                      Rs. <span>{statementDetail?.buyerPaymentInformation?.deliveredOrders?.productPricePaidByBuyer || 0}</span>
                    </p>
                    <p>
                      Rs. <span>0</span>
                    </p>
                  </div>
                </div>
              </div> */}
              <div className="GirthWidtH">
                <div className="girth-One">
                  <div>
                    <p>Closing Balance</p>
                  </div>
                </div>
                <div className="girth-Two">
                </div>
                <div className="girth-Three">
                  <div>
                    <h6>
                      Rs. <span>{statementDetail?.closingBalance || 0}</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>{" "}
        <Card>
          <div className="Number">
            {/* <Row>
              <Col lg="3">
                <h3 className="mt-2 mb-2">Statement Detail</h3>
              </Col>
              
            </Row> */}

            <div className="tab-container">
              <div
              className={`tab ${activeTab === "Order" ? "active" : ""}`}
              onClick={() => setActiveTab("Order")}
              data-testing-id="Order"

            >
              Orders
            </div>
            <div
              className={`tab ${activeTab === "ReturnOrder" ? "active" : ""}`}
              onClick={() => setActiveTab("ReturnOrder")}
              data-testing-id="Retern_Order"
            >
              Return orders
            </div>
            
          </div>
          </div>
    {activeTab === "Order" && (
  <div className="Table-miaN">
    <div className="GirthWidth">
      <div className="girth-One"><h6>Order Detail</h6></div>
      <div className="girth-Two"><h6>Order Creation Date</h6></div>
      <div className="girth-Three"><h6>Release Date</h6></div>
      <div className="girth-Four"><h6>Release Amount</h6></div>
      <div className="girth-Five"><h6>Statement Number</h6></div>
      <div className="girth-Six"><h6>Status</h6></div>
    </div>

    {statementDetail?.orders?.length > 0 ? (
      statementDetail.orders.map((item: any, index: number) => {
        const orderSummary = item?.orderWiseBreakdown;
        const transactionFee = orderSummary?.transactionFee || {};
        const statementNumber = statementDetail?.statementNumber;

        const feeFields = [
          { label: "BuyPass Commission", value: transactionFee.commission },
          { label: "Package Handling Fee", value: transactionFee.packageHandling },
          { label: "Cash Handling Fee", value: transactionFee.cashHandlingFee },
          { label: "Tax Fee", value: transactionFee.tax },
        ];

        return (
          <div className="GirthWidtH" key={item?._id || index}>
            {/* Order Detail */}
            <div className="girth-One">
              <div className="boX">
                <img src={item?.items?.[0]?.productImage} alt="" />
                <div>
                  <p>{item?.items?.[0]?.productName}</p>
                  <p className="seller">Seller SKU: {item?.items?.[0]?.sku}</p>
                  <p className="seller">Order Line ID: {item?.items?.[0]?.productId}</p>
                </div>
              </div>
            </div>

            {/* Order Creation Date */}
            <div className="girth-Two">
              <h6>{formatDate(item?.createdOn)}</h6>
            </div>

            {/* Release Date */}
            <div className="girth-Three">
              <p>{formatDate(item?.createdOn)}</p>
            </div>

            {/* Release Amount */}
            <div className="girth-Four">
              {!openIndexes.includes(index) ? (
                <div
                  className="free d-flex justify-content-between align-items-center"
                  onClick={() => toggleDetails(index)}
                >
                  <h6 className="m-0" style={{ color: "#0877FF" }}>
                    Show Release Amount
                  </h6>
                  <img src={DropDown} alt={`show-fee-${index}`} style={{ width: "12px", height: "8px", cursor: "pointer" }} />
                </div>
              ) : (
                <motion.div
                  initial={{ opacity: 0, y: -20, scale: 0.8, rotate: -5 }}
                  animate={{ opacity: 1, y: 0, scale: 1, rotate: 0 }}
                  exit={{ opacity: 0, y: -20, scale: 0.8, rotate: -5 }}
                  transition={{ type: "spring", stiffness: 100, damping: 25 }}
                >
                  <div className="Amount">
                    <div className="first-amount">
                      <h6>Received Amount</h6>
                      <p>RS: <span>{orderSummary?.amount || 0}</span></p>
                    </div>

                    {feeFields.map((field, idx) =>
                      field.value !== undefined && (
                        <div className="first-Amount" key={idx}>
                          <h5>{field.label}</h5>
                          <p>RS: <span>{field.value}</span></p>
                        </div>
                      )
                    )}
                  </div>

                  <div
                    className="free d-flex justify-content-between align-items-center mt-2"
                    onClick={() => toggleDetails(index)}
                  >
                    <h6 className="m-0" style={{ color: "#0877FF" }}>
                      Hide Release Amount
                    </h6>
                    <img src={DropDown} style={{ transform: "rotate(180deg)", width: "12px", height: "8px", cursor: "pointer" }} alt={`hide-fee-${index}`} />
                  </div>
                </motion.div>
              )}
            </div>

            {/* Statement Number */}
            <div className="girth-Five">
              <div className="text-Overflow">
                <p>{statementNumber || "-"}</p>
                <h6>
                  <span>
                    <i
                      className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                      onClick={(event) => {
                        event.stopPropagation();
                        navigator.clipboard.writeText(statementNumber || "-");
                        setShowModal({ isVisible: true, color: true });
                        setErrorMessage("Statement Number Copied!.");
                        setTimeout(() => {
                          setShowModal({ isVisible: false, color: true });
                        }, 1000);
                      }}
                    ></i>
                  </span>
                </h6>
              </div>
            </div>

            {/* Status */}
            <div className="girth-Six">
              <p>{item?.status}</p>
            </div>
          </div>
        );
      })
    ) : (
      <div className="no-data-found" style={{ textAlign: "center", padding: "20px" }}>
        <p style={{ fontWeight: 500, color: "#999" }}>No orders available.</p>
      </div>
    )}
  </div>
)}

        {activeTab === "ReturnOrder" && (
  <div className="Table-miaN">
    <div className="GirthWidth">
      <div className="girth-One">
        <h6>Order Detail</h6>
      </div>
      <div className="girth-Two">
        <h6>Order Creation Date</h6>
      </div>
      <div className="girth-Three">
        <h6>Release Date</h6>
      </div>
      <div className="girth-Four">
        <h6>Release Amount</h6>
      </div>
      <div className="girth-Five">
        <h6>Statement Number</h6>
      </div>
      <div className="girth-Six">
        <h6>Status</h6>
      </div>
    </div>

    {statementDetail?.returnOrders?.length > 0 ? (
      statementDetail.returnOrders.map((item: any, index: number) => {
        const returnItem = item.returnItem;
        const statementNumber = item?.statementId;
        const returnSummary = item?.returnOrderWiseBreakdown;

        const feeFields = [
          { label: "BuyPass Commission", value: returnSummary?.returnTransactionFee?.commission },
          { label: "Package Handling Fee", value: returnSummary?.returnTransactionFee?.packageHandling },
          { label: "Cash Handling Fee", value: returnSummary?.returnTransactionFee?.cashHandlingFee },
          { label: "Tax Fee", value: returnSummary?.returnTransactionFee?.tax },
        ];

        return (
          <div className="GirthWidtH" key={item?._id || index}>
            <div className="girth-One">
              <div className="boX">
                <img src={returnItem?.productImage} alt="" />
                <div>
                  <p>{returnItem?.productName}</p>
                  <p className="seller">Seller SKU: {returnItem?.sku}</p>
                  <p className="seller">Product ID: {returnItem?.productId}</p>
                </div>
              </div>
            </div>

            <div className="girth-Two">
              <h6>{formatDate(item?.orderCreationTime)}</h6>
            </div>

            <div className="girth-Three">
              <p>{formatDate(item?.createdOn)}</p>
            </div>

            <div className="girth-Four">
              {!openIndexes.includes(index) ? (
                <div
                  className="free d-flex justify-content-between align-items-center"
                  onClick={() => toggleDetails(index)}
                >
                  <h6 className="m-0" style={{ color: "#0877FF" }}>Show Release Amount</h6>
                  <img src={DropDown} alt={`show-fee-${index}`} style={{ width: '12px', height: '8px', cursor: 'pointer' }} />
                </div>
              ) : (
                <motion.div
                  initial={{ opacity: 0, y: -20, scale: 0.8, rotate: -5 }}
                  animate={{ opacity: 1, y: 0, scale: 1, rotate: 0 }}
                  exit={{ opacity: 0, y: -20, scale: 0.8, rotate: -5 }}
                  transition={{ type: "spring", stiffness: 100, damping: 25 }}
                >
                  <div className="Amount">
                    <div className="first-amount">
                      <h6>Received Amount</h6>
                      <p>
                        RS: <span>{returnSummary?.amount}</span>
                      </p>
                    </div>

                    {feeFields.map((field, idx) =>
                      field.value !== undefined && (
                        <div className="first-Amount" key={idx}>
                          <h5>{field.label}</h5>
                          <p>RS: <span>{field.value}</span></p>
                        </div>
                      )
                    )}
                  </div>

                  <div
                    className="free d-flex justify-content-between align-items-center mt-2"
                    onClick={() => toggleDetails(index)}
                  >
                    <h6 className="m-0" style={{ color: "#0877FF" }}>Hide Release Amount</h6>
                    <img src={DropDown} style={{ transform: "rotate(180deg)", width: '12px', height: '8px', cursor: 'pointer' }} alt={`hide-fee-${index}`} />
                  </div>
                </motion.div>
              )}
            </div>

            <div className="girth-Five">
              <div className="text-Overflow">
                <p>{statementNumber || "-"}</p>
                <h6>
                  <span>
                    <i
                      className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                      onClick={(event) => {
                        event.stopPropagation();
                        navigator.clipboard.writeText(statementNumber || "");
                        setShowModal({ isVisible: true, color: true });
                        setErrorMessage("Statement Number Copied!");
                        setTimeout(() => {
                          setShowModal({ isVisible: false, color: true });
                        }, 1000);
                      }}
                    ></i>
                  </span>
                </h6>
              </div>
            </div>

            <div className="girth-Six">
              <p>{item?.status}</p>
            </div>
          </div>
        );
      })
    ) : (
      <div className="no-data-found" style={{ textAlign: 'center', padding: '20px' }}>
        <p style={{ fontWeight: '500', color: '#999' }}>Return Orders not available.</p>
      </div>
    )}
  </div>
)}

          
        </Card>
      </Row>
    </div>
  );
};

export default StateMentOverview;
